export const INDEXED_DB_KEYS = {
  FIREBASE_LOCAL_STORAGE_DB: 'firebaseLocalStorageDb',
} as const;
